import { QuantityUnit, VolumeUnit, WeightUnit } from '~/__generated_types__/globalTypes'
import { GetLoadQuery } from '~/src/components/Operational/LoadBoardDashboard/__generated_types__/queries.gql'

import {
  LegWithEstimates,
  Stop,
} from '~/src/components/Operational/LoadBoardDashboard/types'

export type Note = GetLoadQuery['getLoad']['notes'][0]
export type FreightRecord =
  GetLoadQuery['getLoad']['freightDetails']['freightRecords'][0]

export type MapStopIdToStops = Map<bigint, Stop>

export type MapStopIdToLeg = Map<bigint, LegWithEstimates>

export enum TabName {
  Load = 'Load',
  Map = 'Map',
  Doc = 'Doc',
  Freight = 'Freight',
  Notes = 'Notes',
  Exceptions = 'Exceptions',
}

export enum Unit {
  Quantity = 'Quantity',
  Volume = 'Volume',
  Weight = 'Weight',
}

export type UnitType = VolumeUnit & WeightUnit & QuantityUnit

export type UnitInfo = {
  name: string
  description?: string
}
